import { TestId } from '@components/test-ids';
import styled from '@emotion/styled';
import { Testimonial } from '@model/iceberg/testimonial';
import { mq } from '@styles/breakpoints';
import { withTheme } from '@emotion/react';
import React from 'react';
import { Icon } from '../../generic-icon';
import { StarRating } from '../../star-rating';
import { ThemeProps } from '@theme/base';

export interface ReviewProps {
  testimonial: Testimonial;
}

const Container = styled.div(({ theme }: ThemeProps) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.custom.spacing.medium,
  [mq.small]: {
    padding: theme.custom.spacing.large
  }
}));

const Headline = styled.div(({ theme }: ThemeProps) => ({
  marginTop: theme.custom.spacing.medium,
  marginBottom: 0,
  [mq.small]: {
    marginTop: theme.custom.spacing.large
  },
  color: theme.custom.colors.white,
  ...(theme.custom.typography.h4 as any)
}));

const Author = styled.div(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.h4 as any),
  color: theme.custom.colors.white,
  margin: 0
}));

const ReviewContainer = styled.p(({ theme }: ThemeProps) => ({
  color: theme.custom.colors.white,
  marginTop: theme.custom.spacing.xSmall,
  marginBottom: theme.custom.spacing.xSmall,
  [mq.small]: {
    marginTop: theme.custom.spacing.large,
    marginBottom: theme.custom.spacing.large
  },
  ...(theme.custom.typography.paragraph as any)
}));

const IconContainer = styled.div(({ theme }: ThemeProps) => ({
  opacity: 0.2,
  color: theme.custom.colors.white,
  marginBottom: theme.custom.spacing.medium,
  [mq.small]: {
    marginBottom: theme.custom.spacing.large
  },
  i: {
    color: theme.custom.colors.white
  }
}));

export const ReviewComponent = (props: ReviewProps) =>
  props.testimonial ? (
    <Container data-testid={TestId.testimonial.review}>
      <IconContainer>
        <Icon name={'mhi-quote'} css={{ fontSize: '4rem' }} />
      </IconContainer>
      <StarRating rating={props.testimonial.rating} size={16} />
      <Headline>{props.testimonial.headline}</Headline>
      <ReviewContainer>{props.testimonial.review}</ReviewContainer>
      <Author>{props.testimonial.author}</Author>
    </Container>
  ) : null;

export const Review = withTheme(ReviewComponent);
